import { motion } from "framer-motion";
import { Instagram as InstagramIcon, ArrowUpRight } from "lucide-react";
import { INSTAGRAM_GRID, ORG } from "../data/content";

const ease = [0.22, 1, 0.36, 1];

export default function Instagram() {
  return (
    <section id="instagram" className="bg-sanddark py-16 sm:py-24 lg:py-32" data-testid="instagram-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-12">
        <div className="flex flex-col items-center gap-3 text-center">
          <motion.span
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.6, ease }}
            className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.28em] text-[#B59328]"
          >
            <span className="h-px w-8 bg-[#D4AF37]" /> Follow Our Journey <span className="h-px w-8 bg-[#D4AF37]" />
          </motion.span>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.7, delay: 0.08, ease }}
            className="font-script text-6xl font-bold text-[#0D4B56] sm:text-7xl"
          >
            {ORG.instagramHandle}
          </motion.p>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.7, delay: 0.16, ease }}
            className="max-w-xl text-base text-[#475569] sm:text-lg"
          >
            Flood relief, our Unique Home visit and the exhibition announcement — it all lands here first.
          </motion.p>
        </div>

        <div className="mt-12 grid grid-cols-2 gap-3 sm:grid-cols-3 sm:gap-4" data-testid="instagram-grid">
          {INSTAGRAM_GRID.map((item, i) => (
            <motion.a
              key={i}
              href={ORG.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.55, delay: 0.07 * i, ease }}
              whileHover={{ scale: 0.98 }}
              className="group relative aspect-square overflow-hidden rounded-2xl sm:rounded-3xl"
              aria-label={`View Hope Giver on Instagram: ${item.alt || item.text}`}
              data-testid={`instagram-grid-item-${i}`}
            >
              {item.tile ? (
                <span className="relative flex h-full w-full flex-col items-center justify-center gap-3 bg-gradient-to-br from-[#0D4B56] to-[#08353D] p-4 text-center">
                  <span className="pointer-events-none absolute -right-8 -top-8 h-28 w-28 rounded-full bg-[#D4AF37]/15 blur-xl" />
                  <InstagramIcon size={26} className="text-[#D4AF37]" />
                  <span className="font-script text-2xl font-bold leading-tight text-[#F3E096]">{item.text}</span>
                </span>
              ) : (
                <>
                  <img
                    src={item.src}
                    alt={item.alt}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  <span className="absolute inset-0 flex items-center justify-center bg-[#0D4B56]/70 opacity-0 backdrop-blur-[2px] transition-opacity duration-300 group-hover:opacity-100">
                    <InstagramIcon size={32} className="text-[#F3E096]" />
                  </span>
                </>
              )}
            </motion.a>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2, ease }}
          className="mt-12 text-center"
        >
          <a
            href={ORG.instagramUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="instagram-follow-btn"
            className="inline-flex items-center gap-3 rounded-full bg-gradient-to-r from-[#B59328] via-[#D4AF37] to-[#F3E096] px-9 py-4 text-base font-bold text-[#08353D] shadow-[0_14px_40px_rgba(212,175,55,0.4)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_20px_50px_rgba(212,175,55,0.55)]"
          >
            <InstagramIcon size={20} />
            Follow {ORG.instagramHandle}
            <ArrowUpRight size={18} />
          </a>
        </motion.div>
      </div>
    </section>
  );
}
